import Layout from "../components/utils/layout";
import React from "react";
import Formatters from "../components/utils/formatters";

const MonthlyAccountantsUpdate = () => {
    const screenId="MonthlyAccountantsUpdate"
    const formatters = Formatters()
    const charts = {
        card_orders_by_type:{
            specialFormatters : {
                new_and_additional: formatters.int,
                replacement: formatters.int
            }
        },
        add_new_and_replacement_not_standard:{
            specialFormatters : {
                new_and_additional: formatters.int,
                replacement: formatters.int
            }
        },
        add_new_and_replacement_with_label:{},
        cards_ordered_and_activated_anaq : {
            specialFormatters:{
                date:formatters.isoDate,
                cards_ordered:formatters.int,
                cards_activated:formatters.int
            }
        },
        weekly_stock_usage : {},
        aa_orders_activations_and_actives : {},
        weekly_monthly_loads : {},
    }

    return <Layout prefsPrefix={screenId} items={charts}/>
}

export default MonthlyAccountantsUpdate
